module.exports = __webpack_public_path__ + "media/promo/promo/images/soc-3-6b5575c81ed444d8a8c0b34ac8a370a9.svg";